import axios from 'axios';

// prod: 'https://587ff7jac4.execute-api.us-east-1.amazonaws.com'
const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_RETURNS_API_URL,
});

export default api;
